import React, { useEffect, useState } from 'react';
import { Row, Col, Modal } from "antd";
import { motion } from "framer-motion";
import { useSelector } from "react-redux"
import moment from 'moment-timezone';
import CONFIG from '../config';
import { encrypt } from "../utils/aesDecrypt";
import catalog_2 from "../assets/images/demo-graphic.png"
import LocalUserLoginForm from "./LoginForm"
import BlueButton from './common/BlueButton';

const RevampHome = (props) => {
    const [isLoginModalOpen, setLoginModal] = useState(false);
    const [modalTitle, setModalTitle] = useState(<span style={{ lineHeight: "28px" }}>Sign in</span>);
    const viewport = useSelector(({ viewport }) => viewport);
    const [activeTab, setActiveTab] = useState('home');
    const date = new Date();
    const year = date.getFullYear();
    const plainText = moment().utc().add(process.env.REACT_APP_LOGIN_AES_SALT, 'm').format(CONFIG.dateFormats.scheduler);
    const id = encrypt(plainText);
    const encodedUrl = encodeURIComponent(id);
    const url = `${process.env.REACT_APP_SAML_LOGIN}?id=${encodedUrl}`;


    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.type = 'text/javascript';
        script.setAttribute('data-document-language', 'true');
        script.setAttribute('data-domain-script', '11fcaab1-94a5-4127-a288-57d67b245b37-test');
        document.body.appendChild(script);

        // Define OptanonWrapper function
        window.OptanonWrapper = function () { };
    })

    const loginComplete = () => {
        setLoginModal(false)
        setModalTitle('Sign in')
    }

    const panelData = [
        {
            id: 'home',
            title: 'Live, Clickable Demos',
            text: 'Launch guided, interactive demos that simulate real-world use cases—no static slides, just hands-on experiences.',
            img: 'https://images.news.avaya.com/EloquaImages/clients/AvayaInc/%7B5c0e46ba-b001-43c8-bcdf-2c3932b3fe23%7D_icon-01.png'
        },
        {
            id: 'profile',
            title: 'Global Reach',
            text: 'Accessible worldwide, Show Me Avaya enables teams across regions to deliver consistent, high-impact demos tailored to local market needs.',
            img: 'https://images.news.avaya.com/EloquaImages/clients/AvayaInc/%7B0bb4cd41-eb64-440e-8d42-498c0dca7387%7D_icon-02.png'
        },
        {
            id: 'contact',
            title: 'Always Evolving',
            text: `Show Me Avaya is continuously enhanced with new capabilities, improved user experiences, and expanded demo scenarios. From backend performance upgrades to front-end usability enhancements, the platform evolves to meet the changing needs of our global teams and customers—ensuring every demo stays relevant, impactful, and future-ready.`,
            img: 'https://images.news.avaya.com/EloquaImages/clients/AvayaInc/%7B69dc4e57-a28a-401e-b19b-c8f4a65c279c%7D_icon-03.png'
        },
        {
            id: 'access',
            title: 'Seamless Access & Scheduling',
            text: `Log in with your Avaya SSO to easily schedule and manage demos from a simplified, centralized dashboard. Whether you're planning a customer walkthrough or need to quickly launch a click-through demo on the fly, Show Me Avaya puts everything in one place—organized, accessible, and ready when you are.`,
            img: 'https://images.news.avaya.com/EloquaImages/clients/AvayaInc/%7B5ae155ad-d0a4-47c2-8066-600faeb3eccf%7D_icon-04.png'
        }
    ];

    return (
        <React.Fragment>
            <div style={{ overflowY: "scroll", overflowX: "hidden" }}>
                <div
                    style={{
                        display: "flex",
                        background: "#fff",
                        alignItems: "center",        // vertically center
                        padding: "3rem 5%",             // horizontal gutters
                        boxSizing: "border-box"
                    }}
                    className="home-page-hero"
                >
                    {/* Text column */}
                    <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                        <motion.div
                            style={{ maxWidth: "620px" }}
                        >
                            <div
                                style={{
                                    color: "#000", fontSize: "40px", margin: "4% 0",
                                    lineHeight: "1.2",
                                }}
                                className="oxygen-bold"
                            >
                                Welcome to Show Me Avaya
                            </div>

                            <p
                                style={{
                                    marginTop: "1rem",
                                    color: "#000",
                                    fontWeight: 400
                                }}
                                className="carousel-card-subheading"
                            >
                                Show Me Avaya is your global destination for immersive, real-time demonstrations of Avaya’s most advanced solutions. Designed for Avaya Sales and Business Partners, this platform empowers you to deliver high-impact, industry-specific demo experiences across Financial Services, Healthcare, Retail, Government, Education, and more.
                            </p>

                            <div style={{ marginTop: "2rem" }}>
                                <BlueButton
                                    className="primary-button-avaya primary-action-button-filled"
                                    aria-label="login-filled-home"
                                    onClick={() => {
                                        window.location.pathname === "/home/non-sso-users"
                                            ? setLoginModal(true)
                                            : window.open(url, "_self");
                                    }}
                                >
                                    Sign in
                                </BlueButton>
                            </div>
                        </motion.div>
                    </div>

                    <div
                        style={{
                            flex: 1,
                        }}

                    >
                        <motion.div
                            style={{
                                width: "100%",
                            }}
                        >
                            <img
                                src="../assets/header.png"
                                alt="Avaya Demo Platform"
                                style={{
                                    display: "block",
                                    maxWidth: "140%",
                                    height: "auto",
                                    position: "relative",
                                    left: "-25%",
                                    minWidth: "100%"
                                }}
                            />
                        </motion.div>
                    </div>
                </div>

                <motion.div
                    style={{ background: "white", padding: "50px 0", display: "flex", justifyContent: "center", alignItems: "center", }}
                    className="home-page-section-1 new-animation"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            maxWidth: "1250px",
                            width: "100%",
                            margin: "0 auto",
                            border: "5px solid #E6D6FC",
                            padding: "3rem 5rem",
                            boxSizing: "border-box",
                            gap: "2rem",

                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flex: "1",
                                justifyContent: "flex-start",
                            }}
                        >
                            <div className="img-2-home-content">
                                <div
                                    className="homepage-section-title oxygen-bold"
                                    style={{ fontSize: "34px", width: "460px", lineHeight: "1.2" }}
                                >
                                    Building success <br /> one experience at a time
                                </div>
                                <div
                                    style={{
                                        marginTop: "32px",
                                        width: "550px",
                                        lineHeight: "22px",
                                        marginBottom: "1rem"
                                    }}
                                    className="homepage-section-desc"
                                >
                                    Whether you're showcasing AI-powered contact center workflows, seamless omnichannel engagement, or hybrid cloud deployments, Show Me Avaya provides the tools and infrastructure to bring your story to life.

                                </div>
                            </div>
                        </div>
                        <div className='hero-section-2' style={{
                            display: "flex",
                            flex: "1",
                            justifyContent: "flex-start",
                        }}>
                            <img src="/assets/graphic-01.png" alt="" />
                        </div>
                    </div>
                </motion.div>

                <section style={{ background: "white", padding: "75px 7%" }} className="home-page-tabs-advantages">
                    <div style={{ maxWidth: "1250px", margin: "0 auto" }} className="home-page-tabs-advantages__container container">
                        <nav>
                            <div className="home-page-tabs-advantages__nav nav nav-tabs" role="tablist">
                                {[
                                    { id: 'home', label: 'Live, Clickable Demos' },
                                    { id: 'profile', label: 'Global Reach' },
                                    { id: 'contact', label: 'Always Evolving' },
                                    { id: 'access', label: 'Seamless Access & Scheduling' },
                                ].map(({ id, label }) => (
                                    <button
                                        key={id}
                                        className={`home-page-tabs-advantages__nav-link nav-link${activeTab === id ? ' active' : ''}`}
                                        onClick={() => setActiveTab(id)}
                                        role="tab"
                                        aria-selected={activeTab === id}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                        </nav>

                        <div className="tab-content">
                            {panelData.map(panel =>
                                activeTab === panel.id ? (
                                    <div
                                        key={panel.id}
                                        className="tab-pane fade show active"
                                        role="tabpanel"
                                    >
                                        <div
                                            className='home-page-tabs-advantages__tab-in'
                                            style={{
                                                display: 'flex',
                                                gap: '1.5rem',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <div style={{ flex: 1 }}>
                                                <div style={{ margin: 0, fontSize: "32px", marginBottom: "1rem", fontWeight: "700", lineHeight: "1.2", }}>{panel.title}</div>
                                                <p style={{ marginTop: '0.5rem', fontSize: "16px", lineHeight: "1.5" }}>{panel.text}</p>
                                            </div>

                                            <div style={{ flex: 1 }}>
                                                <img
                                                    src={panel.img}
                                                    alt={panel.title}
                                                    style={{
                                                        maxWidth: '100%',
                                                        display: 'block',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            )}
                        </div>
                    </div>
                </section>

                <div style={{ background: "white", paddingTop: "0px" }} className='new-animation home-page-section-1'>
                    {/* <div style={{ marginTop: "64px" }} className='center-flex'>
                        <span style={{ width: "370px", fontSize: "34px", fontWeight: "700", lineHeight: '1.2', color: "#000" }} className='oxygen-bold'>
                            Show Me Avaya <br />
                            Demo Catalog
                        </span>
                        <span style={{ width: "400px", fontSize: "16px", fontWeight: "400", lineHeight: '24px', color: "#242424", }}>
                            The Show Me Avaya catalog of demos contains demos for products and vertical market solutions across major customer segments.
                        </span>
                    </div> */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            boxSizing: "border-box",
                        }}
                    >
                        <img
                            src={catalog_2}
                            alt="catalog-pic"
                            style={{
                                width: "80%",
                                maxWidth: "1200px",
                                height: "auto",
                                display: "block",
                            }}
                        />
                    </div>
                </div>

                {/* <motion.div
                    style={{ background: "white", padding: "75px 0 0 0" }}
                    className="new-animation home-page-section-1"
                >
                    <div className="section-3-quote-wrapper">
                        <div className="section-3-quote-container">
                            <div className="section-3-quote-row">
                                <div className="section-3-quote-text">
                                    <div className="oxygen-bold" style={{ fontSize: "35px", lineHeight: "1.2", color: "#000" }}>
                                        Avaya is a globally focused company serving markets in Asia, Europe, and the United States
                                    </div>
                                </div>
                                <div className="section-3-quote-text-blue">
                                    <img
                                        src="../assets/icon.png"
                                        alt="Icon"
                                        className="section-3-quote-icon"
                                    />
                                    <div style={{ fontSize: "24px", fontWeight: "400", marginBottom: "2rem", lineHeight: "1.2" }}>Show Me Avaya is built around a simple philosophy:</div>
                                    <p style={{ fontSize: "16px", lineHeight: "24px" }}>
                                        The platform is built on principles of simplicity, flexibility, and enabling Avaya
                                        Associates and Partners to directly correlate Avaya’s capabilities and
                                        differentiation to customer challenges and desired outcomes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div> */}


                <div style={{ background: "white", paddingTop: "130px", }} className='home-page-section-1'>
                    <div className='home-page-image-overlay-3  new-animation' style={{ background: "#D2F5FF" }}>
                        <div className='contact-us-cont'>
                            <div className='oxygen-bold' style={{ fontSize: "30px", width: "100%", textAlign: "center", fontWeight: "700", color: "#151515", lineHeight: "40px" }}>
                                Contact Us
                            </div>
                            <div style={{ marginTop: "1px", paddingLeft: "1rem", paddingRight: "1rem", width: "100%", textAlign: "center", letterSpacing: "0.52px", fontSize: "24px", fontWeight: "300", color: "#151515", lineHeight: "40px" }}>
                                Contact the Show Me Avaya team directly through the demo portal.
                            </div>
                            <div style={{ marginTop: "16px", width: "100%", textAlign: "center", letterSpacing: "0.32px", fontSize: "16px", fontWeight: "400", color: "#151515", lineHeight: "28px" }}>
                                Login using your Avaya Single Sign-On (SSO) credentials.
                            </div>
                            <div style={{ marginTop: "16px", width: "100%", display: "flex", justifyContent: "center" }}>
                                <span style={{ display: 'flex', textAlign: "center", alignItems: "flex-start", gap: "16px" }}>
                                    <BlueButton className='primary-button-avaya primary-action-button-filled' onClick={() => window.open(process.env.REACT_APP_SUPPORT_URL)}  >Contact Support</BlueButton>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style={{ height: "150px", background: "#fff", display: "flex", alignItems: "center", }}>
                        <Row style={{ display: 'flex', width: "100%", padding: "3rem 0 2rem" }}>
                            <Col style={{ flex: 1, justifyContent: "center", display: "flex", fontSize: "16px" }} className="flex-start">
                                <span style={{ color: "#212529" }} >&copy; {year} Avaya, Inc.</span>
                            </Col>
                            <Col style={{ flex: 2, justifyContent: "center", display: "flex", fontSize: "16px", fontWeight: "300" }}>
                                <span><a href="https://www.avaya.com/en/sitemap/" rel="noopener noreferrer" target="_blank" className="black-text">Sitemap</a></span>
                                <span style={{ margin: "0 0.5rem" }}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span><a href="https://www.avaya.com/en/termsofuse/" rel="noopener noreferrer" target="_blank" className="black-text">Terms of Use</a></span>
                                <span style={{ margin: "0 0.5rem" }}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span><a href="https://www.avaya.com/en/privacy/commitment/" rel="noopener noreferrer" target="_blank" className="black-text">Privacy</a></span>
                                <span style={{ margin: "0 0.5rem" }}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                {/* eslint-disable-next-line */}
                                <p style={{ fontSize: '16px', fontWeight: "300" }}><a class="optanon-show-settings black-text" href="javascript:void(0);">Cookies</a></p>
                                <span style={{ margin: "0 0.5rem" }}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span><a href=" https://www.avaya.com/en/trademarks/" rel="noopener noreferrer" target="_blank" className="black-text">Trademarks</a></span>
                                <span style={{ margin: "0 0.5rem" }}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                <span><a href="https://www.avaya.com/en/accessibility/" rel="noopener noreferrer" target="_blank" className="black-text">Accessibility</a></span>
                            </Col>
                        </Row >
                    </div>
                </div>
                {/* </div> */}
                {
                    isLoginModalOpen && <Modal
                        title={modalTitle}
                        wrapClassName="centered-modal" // Assign a custom CSS class for centering the title
                        visible={isLoginModalOpen}
                        onCancel={() => { setLoginModal(false); setModalTitle("Sign In") }}
                        footer={null}
                        className={"login-modal"}
                        width={viewport.isMobileView ? '100%' : '30%'}
                    >
                        <LocalUserLoginForm history={props.history} loginComplete={loginComplete} setModalTitle={setModalTitle} />
                    </Modal>
                }
            </div>
        </React.Fragment >
    )
}

export default RevampHome;